import type { FundVersion } from '@festina/unitlink-general-types/unitlink'
import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { EventVersionWithCommandType } from '../hooks/useFilterCommands'

type FundVersionContext<T extends FundVersion> = {
  currentFundVersion: Optional<T>
  currentFundVersionEventId: Optional<string>
  currentFundVersionEvent: Optional<EventVersionWithCommandType>
  onChangeCurrentFundVersionEventId: (nextId: Optional<string>) => void
}

const [useFundContext, Provider] =
  createRequiredContext<FundVersionContext<FundVersion> | null>(
    'FundVersionContext',
  )

export { Provider, useFundContext }
